import React, {useContext, useEffect, useMemo} from 'react';
import {AuthContext} from "../../../shared/contexts/authContext";
import dayjs from "dayjs";
import {getItemName} from "../../../shared/utils/basic";
import {Sorter} from "../../../shared/components/Sorter";
import {Tag} from "antd";
import LogTemplate from "../../logs/LogTemplate";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {useNavigate} from "react-router-dom";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {getMailLogColumns} from "../../logs/columns/mailLogColumns";

const PlayerMailLog = () => {
    const { playerData } = useContext(PlayerContext);
    const { currentUser } = useContext(AuthContext);

    const navigate = useNavigate();

    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    useEffect(() => {
        if (!playerData.userKey) {
            navigate('/player');
        }
    }, [playerData, navigate]);

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'mailTrash',
        userKey: playerData.userKey,
        isUnix: false,
    };

    const columns = useMemo(() => getMailLogColumns(krItemTextData, currentUser), [krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;
    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={defaultSearchParams}
            routerUrl={'/logs'}
            logName={'MailLog'}
        />
    );
};

export default PlayerMailLog;